<p-popover #popover  styleClass="p-overlaypanel--menu-list-panel {{ useFixedPosition ? 'p-overlaypanel--fixed' : '' }} {{ positionCenter ? 'p-overlaypanel-center' : '' }}">
<!--  <ng-template pTemplate>-->
      <bulb-menu-list
        *ngIf="listType !== 'RADIO'"
        [menuItems]="menuItems"
        (menuItemClicked)="menuItemClicked($event)"
        [footerTemplate]="footerTemplate"
      ></bulb-menu-list>
      <form [formGroup]="formGroup" *ngIf="listType === 'RADIO'">
        <bulb-radio-list
          [menuItems]="menuItems"
          (menuItemClicked)="menuItemClicked($event)"
          [footerTemplate]="footerTemplate"
          [formControlName]="'radioListControl'"
        ></bulb-radio-list>
      </form>
<!--    </ng-template>-->
</p-popover>

<ng-container
  *ngTemplateOutlet="buttonTemplate || buttonTemplateDefault"
></ng-container>

<ng-template #buttonTemplateDefault>
  <button
    *transloco="let t; read: 'menus'"
    #toggleEl
    aria-haspopup="true"
    [attr.aria-expanded]="isOpen"
    [attr.aria-label]="t(buttonLabelKey)"
  >
    <svg-icon
      key="ellipsis-h"
      fontSize="2.5em"
      class="menu-list-button">
    </svg-icon>
  </button>
</ng-template>
